import { STOP_EVENTS_LOADING } from "./types";

const stopBookingsLoading = () => ({
  type: STOP_EVENTS_LOADING,
});

export default stopBookingsLoading;
